import React from "react";
import { BrowserRouter } from "react-router-dom";
import { Router } from "@components/Router";

import "bootstrap/dist/css/bootstrap.css";

export default function App() {
    const baseUrl = `${window.location.protocol}//${window.location.host}`;
    const uidUserEntity = localStorage.getItem("Uid_Entitie_User");
    const [isLoading, setIsLoading] = React.useState(true);
    const fetchListUidEntityBeta = async () => {
        try {
            const url = `${
                process.env.REACT_APP_UUID_BETA
            }?cacheBuster=${Date.now()}`;
            const response = await fetch(`${url}`);
            if (!response.ok) {
                throw new Error(
                    `Erreur lors du chargement des données: ${response.status} ${response.statusText}`
                );
            }
            const data = await response.json();

            return data;
        } catch (error) {
            // eslint-disable-next-line
            console.error(
                "Erreur lors du chargement de listUidEntity :",
                error
            );
            return [];
        }
    };

    React.useEffect(() => {
        if (
            uidUserEntity &&
            process.env.REACT_APP_BETA !== process.env.REACT_APP_PROD
        ) {
            fetchListUidEntityBeta().then((UidEntityBeta) => {
                const isUserBeta = UidEntityBeta.some(
                    (item: any) => item.uuidEntity === uidUserEntity
                );

                const redirectTo = isUserBeta
                    ? process.env.REACT_APP_BETA
                    : process.env.REACT_APP_PROD;

                if (redirectTo && redirectTo !== baseUrl) {
                    localStorage.clear();
                    const newUrl = `${redirectTo}`;
                    try {
                        window.location.replace(newUrl);
                    } catch (error) {
                        // eslint-disable-next-line
                        console.error("Erreur lors de la redirection :", error);
                    }
                }
                setIsLoading(false);
            });
        } else {
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [uidUserEntity]);

    return isLoading ? null : (
        <BrowserRouter>
            <Router />
        </BrowserRouter>
    );
}
